<template>
    <!-- A belt based syllabus keeps the belt code in `level`, stripe count and
         all - "white1", "gray_white", "coral". That is not a colour the browser
         can use, so hand it to the belt display, which is what draws the same
         bar everywhere else. -->
    <BeltContainer v-if="usesBelts" :height="height" :belt="curriculumData.level" />
    <v-row v-else no-gutters>
        <v-col cols="12"
            :style="'border-radius:5px 0 0 0;height:' + (height ? height : '100') + 'px;background-color:' + primaryColor">
        </v-col>
    </v-row>
</template>

<script>
import BeltContainer from "@/components/displays/BeltContainer";

export default {
    props: ["curriculumData", "height"],
    components: {
        BeltContainer,
    },
    computed: {
        usesBelts() {
            return !!(this.curriculumData && this.curriculumData.useBelts);
        },
        primaryColor() {
            const color = this.curriculumData ? this.curriculumData.color : null;
            //A level with no colour picked used to fall through to the level's
            //own name - "Level 3" - which the browser discards, leaving the
            //header blank. Fall back to the neutral grey so there is always
            //something behind the picture. Deliberately not primary: that is a
            //text colour, black in light mode and white in dark, so it reads as
            //a black or white belt rather than as a level with no colour.
            return color ? color : this.themeColor("neutral");
        },
    },
};
</script>

<style scoped></style>
